<template>
  <skud-guest-list />
</template>

<script>
import SkudGuestList from '@/views/skud/components/SkudGuestList.vue'

export default {
  name: 'AdminSkudGuestList',
  components: { SkudGuestList }
}
</script>
